import {
    type FC
} from "react";
import {
} from "react-native";
import type {
    FormWidgetProps
} from "./type";
import PhotoWidget from "./components/photoWidget";
import {
    NCoreUIKitTheme,
    SelectBox,
    TextAreaInput,
    TextInput
} from "ncore-ui-kit";
import type {
    FormFieldsObjectType
} from "../../../../../services/restAPI/actions/getEventApplicationForm/types";

const StringWidget: FC<FormWidgetProps> = ({
    field,
    value,
    onChange,
    isDisabled
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TextInput
        title={field.title}
        maxLength={field.maxLength}
        multiline={false}
        placeholder={field.title}
        spreadBehaviour="stretch"
        defaultValue={value}
        isRequired={field.isRequired !== false}
        isDisabled={isDisabled}
        onChangeText={(e) => {
            onChange(e);
        }}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

const LongTextWidget: FC<FormWidgetProps> = ({
    field,
    value,
    onChange,
    isDisabled
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TextAreaInput
        title={field.title}
        maxLength={field.maxLength}
        placeholder={field.title}
        spreadBehaviour="stretch"
        defaultValue={value}
        isRequired={field.isRequired !== false}
        isDisabled={isDisabled}
        onChangeText={(e) => {
            onChange(e);
        }}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

const NumberWidget:FC<FormWidgetProps> = ({
    field,
    value,
    onChange,
    isDisabled
}) =>{
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TextInput
        title={field.title}
        maxLength={field.maxLength}
        keyboardType="phone-pad"
        multiline={false}
        placeholder={field.title}
        spreadBehaviour="stretch"
        defaultValue={value}
        isRequired={field.isRequired !== false}
        isDisabled={isDisabled}
        onChangeText={(e) => {
            onChange(e);
        }}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

const PhoneWidget: FC<FormWidgetProps>  = ({
    field,
    value,
    onChange,
    isDisabled
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TextInput
        title={field.title}
        maxLength={field.maxLength}
        keyboardType="phone-pad"
        multiline={false}
        placeholder={field.title}
        spreadBehaviour="stretch"
        defaultValue={value}
        isRequired={field.isRequired !== false}
        isDisabled={isDisabled}
        onChangeText={(e) => {
            onChange(e);
        }}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

const MailWidget: FC<FormWidgetProps> = ({
    field,
    value,
    onChange,
    isDisabled
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TextInput
        title={field.title}
        maxLength={field.maxLength}
        keyboardType="email-address"
        multiline={false}
        placeholder={field.title}
        spreadBehaviour="stretch"
        defaultValue={value}
        isRequired={field.isRequired !== false}
        isDisabled={isDisabled}
        onChangeText={(e) => {
            onChange(e);
        }}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

const SelectboxWidget: FC<FormWidgetProps> = ({
    field,
    onChange,
    isDisabled
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    const minChoice = field.minLength ? field.minLength : 1;
    const maxChoice = field.maxLength ? field.maxLength : 1;
    const isMultipleSelect = maxChoice > 1;

    return <SelectBox
        keyExtractor={(e) => e.key}
        titleExtractor={(e) => e.title}
        data={field.options ? field.options : []}
        spreadBehaviour="stretch"
        title={field.title}
        isRequired={field.isRequired !== false}
        isWorkWithRealtime={false}
        isCleanEnabled={false}
        isMultipleSelect={isMultipleSelect}
        isDisabled={isDisabled}
        maxChoice={maxChoice}
        minChoice={minChoice}
        onOk={(
            selectedItems
        ) => {
            if(selectedItems && selectedItems.length) {
                onChange(selectedItems.map((item) => item.__key).join(","));
            }}}
        style={{
            marginBottom: spaces.spacingMd
        }}
    />;
};

export const FormRegistry: Record<FormFieldsObjectType["type"], FC<FormWidgetProps> >= {
    string: StringWidget,
    longText: LongTextWidget,
    number: NumberWidget,
    phone: PhoneWidget,
    mail: MailWidget,
    selectbox: SelectboxWidget,
    photo: PhotoWidget,
    defaultField: StringWidget
};
